const GEPT_LABEL_KEY_PAIRS = [
  ['初級', 'beginner'],
  ['中級', 'intermediate'],
  ['模擬試題', 'mockExam'],
  ['歷屆考古題', 'pastExam'],
  ['全部題目', 'allQuestions'],
  ['複誦', 'repeat'],
  ['朗讀句子與短文', 'readSentences'],
  ['回答問題', 'answerQuestion'],
  ['描述圖片', 'describeImage'],
  ['朗讀短文', 'readPassage'],
  ['看圖敘述', 'describePicture'],
  ['單句寫作', 'singleSentenceWriting'],
  ['段落寫作', 'paragraphWriting'],
  ['中譯英', 'chineseToEnglish'],
  ['英文作文', 'englishComposition'],
  ['句子改寫', 'sentenceRewrite'],
  ['句子合併', 'sentenceMerge'],
  ['句子重組', 'sentenceReorder'],
  ['重組', 'sentenceReorder'],
  ['看圖表寫作', 'pictureWriting']
]

const GEPT_PRECAUTION_KEY_PAIRS = [
  ['初級', [
    ['單句寫作', 'beginnerSingleSentenceWriting'],
    ['段落寫作', 'beginnerParagraphWriting'],
    ['複誦', 'beginnerRepeat'],
    ['朗讀句子與短文', 'beginnerReadSentences'],
    ['回答問題', 'beginnerAnswerQuestion']
  ]],
  ['中級', [
    ['中譯英', 'intermediateChineseToEnglish'],
    ['英文作文', 'intermediateEnglishComposition'],
    ['朗讀短文', 'intermediateReadPassage'],
    ['回答問題', 'intermediateAnswerQuestion'],
    ['看圖敘述', 'intermediateDescribePicture']
  ]]
]

const GEPT_LABEL_KEY_MAP = GEPT_LABEL_KEY_PAIRS.reduce((map, [label, key]) => {
  map[label] = key
  return map
}, {})

const GEPT_PRECAUTION_KEY_MAP = GEPT_PRECAUTION_KEY_PAIRS.reduce((map, [level, pairs]) => {
  map[level] = pairs.reduce((levelMap, [label, key]) => {
    levelMap[label] = key
    return levelMap
  }, {})
  return map
}, {})

const GEPT_PART_LABEL_KEYS = [
  'firstPart',
  'secondPart',
  'thirdPart',
  'fourthPart',
  'fifthPart',
  'sixthPart'
]

export default {
  methods: {
    geptLabel (value) {
      const key = GEPT_LABEL_KEY_MAP[value]
      return key ? this.$t(`GEPT.labels.${key}`) : value
    },

    geptDisplayText (text) {
      return Object.keys(GEPT_LABEL_KEY_MAP).reduce((result, label) => {
        return result.replace(new RegExp(label, 'g'), this.geptLabel(label))
      }, String(text || ''))
    },

    geptPracticeTypeLabel (type) {
      return type === 'writing'
        ? this.$t('GEPT.common.writingPractice')
        : this.$t('GEPT.common.speakingPractice')
    },

    geptExamTypeLabel (type) {
      if (type === 'writing') return this.$t('GEPT.common.writing')
      if (type === 'speaking') return this.$t('GEPT.common.speaking')
      return type || ''
    },

    geptNextActionLabel (showNextType) {
      return showNextType
        ? this.$t('GEPT.common.nextType')
        : this.$t('GEPT.common.submitReport')
    },

    geptPartLabel (index) {
      const key = GEPT_PART_LABEL_KEYS[index]
      return key
        ? this.$t(`GEPT.labels.${key}`)
        : this.$t('GEPT.labels.partWithNumber', { number: index + 1 })
    },

    geptPrecautionDescription (level, unit, title) {
      const levelMap = GEPT_PRECAUTION_KEY_MAP[level] || {}
      const key = levelMap[unit] || levelMap[title]
      return key ? this.$t(`GEPT.precautions.${key}`) : ''
    }
  }
}
